<template>
	<div v-if="!_gHlp.isEmpty(tableData)">
		<el-table ref="multipleTable" :data="tableData" style="width: 100%" size="mini">
			<el-table-column label="Options"  min-width="200" label-class-name="py-0">
				<template slot="header">
					<small>Options</small>
				</template>
				<template slot-scope="scope">
					{{ scope.row.label }}
				</template>
			</el-table-column>

			<el-table-column label="Redemption Date"  min-width="120" label-class-name="py-0">
				<template slot="header">
					<small>Redemp. Date</small>
				</template>
				<template slot-scope="scope">
					{{ _gHlp.formatMomentDate(scope.row.due_date,'D MMM, YYYY') }}
				</template>
			</el-table-column>

			<el-table-column label="Last Balance Date"  min-width="120" label-class-name="py-0">
				<template slot="header">
					<small>Last Bal. Date</small>
				</template>
				<template>
					{{ _gHlp.formatMomentDate(detail.redem_date,'D MMM, YYYY') }}
				</template>
			</el-table-column>

			<el-table-column label="Last Balance Amount"  min-width="120" label-class-name="py-0">
				<template slot="header">
					<small>Last Bal. Amount</small>
				</template>
				<template>
					{{ detail.balance_amt | moneyFormatter }}
				</template>
			</el-table-column>

			<el-table-column label="Formula"  min-width="250" label-class-name="py-0">
				<template slot="header">
					<small>Formula</small>
				</template>
				<template slot-scope="scope">
					<div v-if="scope.$index > 0">
						<span class="d-flex  align-items-center justify-content-between">
							<small class="d-block-inline">Previous Balance</small>
							<small class="d-block-inline">{{ _gHlp.getValue(scope.row,'formula.prev_balance',0) | moneyFormatter }}</small>
						</span>
						<span class="d-flex  align-items-center justify-content-between">
							<small class="d-block-inline">Next Month Interest</small>
							<small class="d-block-inline text-success">{{ _gHlp.getValue(scope.row,'formula.interest_amt',0) | moneyFormatter }}</small>
						</span>
						<span class="d-flex  align-items-center justify-content-between">
							<small class="d-block-inline">Advanced Instalment</small>
							<small class="d-block-inline text-danger">{{ _gHlp.getValue(scope.row,'formula.advc_balance',0) | moneyFormatter }}</small>
						</span>
					</div>
					<div v-else>
						last statement balance as of {{ _gHlp.formatMomentDate(scope.row.due_date,'D MMM, YYYY') }}
					</div>
				</template>
			</el-table-column>

			<el-table-column label="Settlement Amount"  min-width="120" label-class-name="py-0">
				<template slot="header">
					<small>Bal. Amount</small>
				</template>
				<template slot-scope="scope">
					{{ scope.row.settlement_amt | moneyFormatter }}
				</template>
			</el-table-column>

			<el-table-column type="expand">
				<template slot-scope="props">
					<div class="p-3">
						Detail Repayment Balance
						<ul>
							<li class="text-wrap" v-for="(item,index) in props.row.breakdown" :key="index">{{ item }}</li>
						</ul>
					</div>
				</template>
			</el-table-column>
			
		</el-table>
	</div>
</template>
<script>
import { Table, TableColumn } from 'element-ui'
import _ from 'lodash'

export default {
	props: ['redemption'],
	components: {
		[Table.name]: Table,
		[TableColumn.name]: TableColumn
	},
	data() {
		return {
			detail: {},
			tableData: [],
		}
	},
	watch: {
		'redemption': {
			handler(newValue, oldValue) {
				if(newValue){
					this.detail = _.cloneDeep(newValue)
					this.tableData = _.cloneDeep(newValue.simulate_detail)
				}
			},
			immediate: true
		},
	},
	methods: {
		
	}
}
</script>